import { isDefined } from "Utils/functions";

const licenseFormatRegex = /^([a-zA-Z]{1,2})(\s*)(\d{0,5})/;
const shortLicenseFormatRegex = /^([a-zA-Z]{1,2})(\s*)(\d{0,4})/;
const shortLicenseOrUnregisteredFormatRegex =
  /(^(([Uu]{1}[Rr]{0,1}[Ee]{0,1}[Gg]{0,1})(.*))$)|(^[a-zA-Z]{1,2})(\s*)(\d{0,4})/;
const customLicenseFormatRegex =
  /^([0-9a-zA-ZæøåÆØÅ]{1,2})(\s*)([0-9a-zA-ZæøåÆØÅ]{0,5})/;
const compactLicenseFormatRegex = /^([a-zA-Z]{1,2}(?:[0-9a-zA-ZæøåÆØÅ]){0,5})/;

export enum LicensePlateFormat {
  custom,
  default,
  short,
  shortOrUnregistered,
  compact,
}

function regexFor(format: LicensePlateFormat): RegExp {
  switch (format) {
    case LicensePlateFormat.custom:
      return customLicenseFormatRegex;
    case LicensePlateFormat.short:
      return shortLicenseFormatRegex;
    case LicensePlateFormat.shortOrUnregistered:
      return shortLicenseOrUnregisteredFormatRegex;
    case LicensePlateFormat.compact:
      return compactLicenseFormatRegex;
    case LicensePlateFormat.default:
    default:
      return licenseFormatRegex;
  }
}

export function formatLicensePlate(
  license: string,
  format: LicensePlateFormat = LicensePlateFormat.default,
): string {
  const re = regexFor(format);
  if (re.test(license)) {
    const matches = license.match(regexFor(format));
    if (matches !== null) {
      return handleSpecialMatchingCases(format, matches);
    }
  }
  return "";
}

const handleSpecialMatchingCases = (
  format: LicensePlateFormat,
  matches: RegExpMatchArray,
): string => {
  if (matches.length === 2) {
    return matches[1].toUpperCase();
  } else if (format === LicensePlateFormat.shortOrUnregistered) {
    if (isMatchForTwoLetterUnregistered(matches)) {
      return matches[5].toUpperCase();
    } else if (isMatchForTwoLetters(matches)) {
      return matches[3].toUpperCase();
    } else if (isMatchForLettersAndNumbers(matches)) {
      return `${matches[5].toUpperCase()} ${matches[7].toUpperCase()}`;
    } else if (matches[5].length === 2 && matches[6] === " ") {
      return `${matches[5].toUpperCase()} `;
    }
  } else if (matches[1].length === 2 && matches[3].length > 0) {
    return `${matches[1].toUpperCase()} ${matches[3].toUpperCase()}`;
  } else if (matches[2].length > 0) {
    return `${matches[1].toUpperCase()} `;
  }
  return matches[1].toUpperCase();
};

const isMatchForTwoLetterUnregistered = (matches: RegExpMatchArray): boolean =>
  isDefined(matches[5]) &&
  matches[5].length > 0 &&
  matches[6] !== " " &&
  matches[7] === "";

const isMatchForTwoLetters = (matches: RegExpMatchArray): boolean =>
  isDefined(matches[3]) && matches[3].length > 0;

const isMatchForLettersAndNumbers = (matches: RegExpMatchArray): boolean =>
  matches[5].length === 2 && matches[7].length > 0;
